import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { ServicePlanBillingPolicyFormSchemaValues } from 'src/features/servicePlanBillingPolicies/utils/formSchema';
import { ServicePlanBillingPolicy } from 'src/features/servicePlanBillingPolicies/utils/types';

const RESOURCE = '/subscriptions/service-plan-item/:servicePlanItemId/service-plan-item-billing-policy/';

type MutationFnType = typeof mutationFn;

interface DTO extends ServicePlanBillingPolicyFormSchemaValues {
    servicePlanItemId: string;
}

const mutationFn = ({ servicePlanItemId, ...data }: DTO): Promise<ServicePlanBillingPolicy> => {
    return axios.post(formatResourcePath(RESOURCE, { servicePlanItemId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateServicePlanBillingPolicy };
